import { ComponentRoute } from '@/classes'

const ReturnPartsRoutes = {
  ReturnPartsListView: new ComponentRoute('/returnparts', 'ReturnPartsListView'),
  ReturnPartsView: new ComponentRoute('/returnparts/:creditReturnMainId', 'ReturnPartsView'),
  ReturnPartsDetail: new ComponentRoute('/returnparts/:creditReturnMainId', 'ReturnPartsDetail')
}

export default ReturnPartsRoutes